export default "__VITE_ASSET__D0Td4RW9__"